import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { HeadingModule } from '../heading/heading.module';

/* Material Imports */
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SideNavHeaderComponent } from '../header/header.component';
import { FlexModule } from '@angular/flex-layout';
// Services
// import { TranslationService } from '../change-company/services/translation.service';
import { ZonarUICoreModule } from '@app/modules/core';
import { ZonarUIMaterialModule } from '@livemaps/material';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginButtonModule } from '../sidenav-login-button/sidenav-login-button.module';
import { SidenavConfig, SidenavConfigService, SidenavModuleConfig } from '../config/sidenav-config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { showTooltipIfTruncated } from '../tooltip-directive';
// Pattern Library Modules

@NgModule({
  declarations: [SidenavComponent, SideNavHeaderComponent, showTooltipIfTruncated],
  imports: [
    CommonModule,
    HeadingModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ZonarUICoreModule,
    ZonarUIMaterialModule,
    MatTooltipModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    LoginButtonModule,
    FlexModule
    // ZonarUIBrandModule
    // ZonarUiI18nModule
  ],
  providers: [
    SidenavConfig,
    // TranslationService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: MatDialogRef, useValue: MatDialogRef }
  ],
  exports: [SidenavComponent, SideNavHeaderComponent, showTooltipIfTruncated]
})
export class SidenavModule {
  static forRoot(config?: SidenavModuleConfig): ModuleWithProviders<SidenavModule> {
    return {
      ngModule: SidenavModule,
      providers: [SidenavConfig, { provide: SidenavConfigService, useValue: config }]
    };
  }
}
